function getStorageKey(userId: string, deviceId: string): string {
    return `seenChecks_${userId}_${deviceId}`;
}

export function hasSeenPage(userId: string | undefined, deviceId: string): boolean {
    if (!userId) {
        return false;
    }
    const key = getStorageKey(userId, deviceId);
    return localStorage.getItem(key) === 'true';
}

export function markPageAsSeen(userId: string | undefined, deviceId: string): void {
    if (!userId) {
        return;
    }
    const key = getStorageKey(userId, deviceId);
    localStorage.setItem(key, 'true');
}
